import { downloadTicketPdfApi } from 'app/services/checkoutApi';
import React, { useState } from 'react';
import { ReactComponent as DownloadIcon } from 'app/assets/img/download.svg';
import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { selectTranslations } from 'app/pages/App/slice/selectors';

const DownLoadIcon = ({ searchParams, name }) => {
  const translations = useSelector(selectTranslations);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Tooltip
      color="white"
      title={translations?.['b2c.pdf.download']}
      overlayInnerStyle={{
        color: 'black',
      }}
    >
      <div style={{ width: 20, height: 20 }}>
        {isLoading ? (
          <LoadingOutlined style={{ fontSize: 16, color: '#F8B117' }} spin />
        ) : (
          <DownloadIcon
            style={{ cursor: 'pointer' }}
            onClick={() =>
              downloadTicketPdfApi(searchParams, setIsLoading, name)
            }
          />
        )}
      </div>
    </Tooltip>
  );
};

export default DownLoadIcon;
